export const CELL_POPOVER_WIDTH = 960
